/* AZCP pure vehicle helpers. ESM exports for tests; window.AZCP.pure side-effect for browser. */
'use strict';

export function sanitizeEngineLabel(raw) {
  if (!raw) return '';
  var s = String(raw).replace(/^[-–—]+\s*/, '');
  s = s.replace(/\s*;.*$/, '');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}

export function parseFacets(html, paramByField) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var result = { category: [], make: [], model: [], engine: [], year: [] };
  Object.keys(paramByField).forEach(function (field) {
    var name = paramByField[field];
    var inputs = doc.querySelectorAll('input[name="' + name + '"]');
    var seen = {};
    var arr = [];
    inputs.forEach(function (input) {
      var value = input.getAttribute('value') || '';
      if (!value) return;
      if (seen.hasOwnProperty(value)) return;
      // Shopify marks options with 0 matching products as `disabled` — drop those entirely
      // so the user can't pick a combination that yields no results.
      if (input.disabled || input.hasAttribute('disabled')) return;
      var labelEl = doc.querySelector('label[for="' + input.id + '"] .facet-checkbox__text-label');
      var label = labelEl ? labelEl.textContent.trim() : value;
      // Count lives in the sibling parent (`.facet-checkbox__text`) which contains
      // the label PLUS a trailing " (N)" — read the outer text and extract the count.
      var textWrapper = doc.querySelector('label[for="' + input.id + '"] .facet-checkbox__text');
      var count = null;
      if (textWrapper) {
        var allText = textWrapper.textContent || '';
        var countMatch = allText.match(/\(([\d,]+)\)\s*$/);
        if (countMatch) count = parseInt(countMatch[1].replace(/,/g, ''), 10);
      }
      // Fallback: some markup may include the count directly inside the text-label
      if (count == null) {
        var inlineMatch = label.match(/\(([\d,]+)\)\s*$/);
        if (inlineMatch) {
          count = parseInt(inlineMatch[1].replace(/,/g, ''), 10);
          label = label.replace(/\s*\(\d[\d,]*\)\s*$/, '');
        }
      }
      if (field === 'engine') label = sanitizeEngineLabel(label);
      seen[value] = true;
      arr.push({ value: value, label: label, count: count });
    });
    arr.sort(function (a, b) { return a.label.localeCompare(b.label); });
    result[field] = arr;
  });
  return result;
}

export function matchesVehicle(saved, productFitment) {
  if (!productFitment) return 'no-data';
  var keys = Object.keys(productFitment);
  if (keys.length === 0) return 'no-data';
  // any key present in productFitment is normalized to an array of strings
  function arr(v) { return Array.isArray(v) ? v : (v ? [String(v)] : []); }
  var pf = {
    make: arr(productFitment.make),
    model: arr(productFitment.model),
    engine: arr(productFitment.engine),
    year: arr(productFitment.year)
  };
  // Make required for any judgement; if product has no fitment data at all → no-data
  var anyData = pf.make.length || pf.model.length || pf.engine.length || pf.year.length;
  if (!anyData) return 'no-data';

  // Any saved field that conflicts with product fitment → no-fit
  if (saved.make && pf.make.length && pf.make.indexOf(saved.make) === -1) return 'no-fit';
  if (saved.model && pf.model.length && pf.model.indexOf(saved.model) === -1) return 'no-fit';
  if (saved.engine && pf.engine.length && pf.engine.indexOf(saved.engine) === -1) return 'no-fit';
  if (saved.year && pf.year.length && pf.year.indexOf(String(saved.year)) === -1) return 'no-fit';

  // Saved missing a field that product specifies → maybe
  if (!saved.model && pf.model.length) return 'maybe';
  if (!saved.engine && pf.engine.length) return 'maybe';
  if (!saved.year && pf.year.length) return 'maybe';

  return 'fit';
}

export const FIELD_ORDER = ['category', 'make', 'model', 'engine', 'year'];

export function applyCascadeReset(values, changedField) {
  var idx = FIELD_ORDER.indexOf(changedField);
  if (idx === -1) return Object.assign({}, values);
  var out = {};
  for (var i = 0; i < idx; i++) {
    var f = FIELD_ORDER[i];
    if (values[f] !== undefined && values[f] !== null && values[f] !== '') out[f] = values[f];
  }
  return out;
}

if (typeof globalThis !== 'undefined') {
  globalThis.AZCP = globalThis.AZCP || {};
  globalThis.AZCP.pure = Object.assign(globalThis.AZCP.pure || {}, {
    sanitizeEngineLabel: sanitizeEngineLabel,
    parseFacets: parseFacets,
    matchesVehicle: matchesVehicle,
    applyCascadeReset: applyCascadeReset,
    FIELD_ORDER: FIELD_ORDER
  });
}
